import {PageProps} from 'gatsby'
import {
    withPrismicPreview as withPrismicPreviewHOC,
    WithPrismicPreviewProps,
    UnknownRecord,
} from 'gatsby-plugin-prismic-previews'
import React from 'react'

import {prismicConfig} from '@/config/prismic-config'

/**
 * A thin wrapper around withPrismicPreview, pre-filling the repository info and
 * some options, as these should always be the same.
 *
 * @see
 * https://github.com/angeloashmore/gatsby-source-prismic/blob/alpha/packages/gatsby-plugin-prismic-previews/docs/api-withPrismicPreview.md
 */
export const withPrismicPreview = <
    TStaticData extends UnknownRecord<PropertyKey>,
    TProps extends PageProps<TStaticData, object, unknown>
>(
    component: React.ComponentType<TProps & WithPrismicPreviewProps<TStaticData>>
) => {
    if (!prismicConfig.repositoryName) {
        throw new Error('Missing `repositoryName` in `withPrismicPreview`')
    }

    if (!prismicConfig.linkResolver) {
        throw new Error('Missing `linkResolver` in `withPrismicPreview`')
    }

    return withPrismicPreviewHOC(component, [
        {
            repositoryName: prismicConfig.repositoryName,
            linkResolver: prismicConfig.linkResolver,
            transformFieldName: prismicConfig.transformFieldName,
        },
    ])
}
